<template>
  <vue-draggable-resizable
    :w="500"
    :h="100"
    :parent="true"
    :y="80"
    :x="90"
    :resizable="false"
    id="floatingCall">
    <v-container class="container-content-2" fluid v-if="isReady">
      <v-layout row wrap class="container-content">
        <v-flex xs2>
          <avatar
            :initials="String(notification.name || 'Desconocido').charAt(0)"
            :size="60"
            background-color="#ff7c64"
            color="#fff"
            class="text-capitalize">
          </avatar>
        </v-flex>
        <v-flex xs3>
          <h2 class="text-white text-capitalize">
            {{ notification.name || 'Desconocido' }}
          </h2>
          <small class="text-white">
            {{ phone }}
            <br />
            {{ timer }}
            <template v-if="notification.type_id === 9">
              <br />
              <v-icon icon small class="k-orange-linear pa-2 mr-2" style="border-radius: 90px">
                fas fa-robot
              </v-icon> Derivado del bot - <strong>{{ notification.ns_status }}</strong>
            </template>
          </small>
        </v-flex>
        <v-flex id="containerBtnDial" xs6>
          <div class="text-xs-center d-flex">
            <!-- <save-btn
              :call = "notification"
              @expand-item="stopRecord"
            /> -->
            <v-btn color="k-blue-linear" fab @click="$store.dispatch('manualCalls/muteCall')">
              <v-icon v-if="!isMuted" color="white">
                fas fa-microphone
              </v-icon>
              <v-icon v-if="isMuted" color="white">
                fas fa-microphone-slash
              </v-icon>
            </v-btn>
            <v-btn
              color="red" fab @click="$store.dispatch('manualCalls/hangupCall')">
              <v-icon color="white">
                fas fa-phone fa-rotate-90
              </v-icon>
            </v-btn>
          </div>
        </v-flex>
          <v-flex v-if="showWarningTime" class="d-flex align-center justify-center extra-warning">
              <small class="black--text timer-text">
                <v-icon class="rotating-clock" size="24px" color="black">timer</v-icon>
              </small>
              <b>{{ warningTime }}</b>
            </v-flex>
            <v-flex v-else-if="showAlertTime" column class="extra-alert">
              <div class="w-100">
                <small class="white--text">
                  <v-icon class="rotating-clock" size="15px" color="white">timer</v-icon> {{ textAlertHuman }}
                </small>
              </div>
              <div v-if="soundIsRunning" class="w-100">
                <v-btn block small color="white" class="red--text btn-alert" @click="endSound()">
                  <v-icon class="material-icons" size="20px" color="red">
                    notifications_active
                  </v-icon><span class="space-simulated">Desactivar alarma</span>
                </v-btn>
              </div>
            </v-flex>
      </v-layout>
    </v-container>
  </vue-draggable-resizable>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import Avatar from 'vue-avatar';
import permissionsMixin from '@/mixins/permissions';
import callTimeAndAlertMixin from '@/mixins/callTimeAndAlert';
import moment from 'moment';

export default {
  mixins: [
    permissionsMixin,
    callTimeAndAlertMixin,
  ],
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  components: {
    Avatar,
    VueDraggableResizable,
  },
  data() {
    return {
      isSaving: false,
    };
  },
  computed: {
    isReady() {
      return this.$store.state.manualCalls.room;
    },
    phone() {
      let phone = this.notification.phone;
      if (!this.canSeeMasked && !phone.includes('*')) {
        const length = phone.length - 3;
        const chars = '*'.repeat(length);
        phone = `${chars}${phone.slice(-3)}`;
      }
      return phone;
    },
    canSeeMasked() {
      return this.checkPermissions([
        'see_masked_data',
      ]); 
    },
    isMuted() {
      return this.$store.state.manualCalls.audioTrack.isMuted;
    },
  },
  watch: {
    isReady(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.$store.commit(
          'callTimeAndAlert/SET_CURRENT_STATUS_START_TIME',
          moment.utc().unix(),
          { root: true },
        );
      }
    },
  },
};
</script>

<style scoped>
#floatingCall {
  z-index: 200 !important;
  max-width: 40vw !important;
}
#floatingCall .container {
  background-color: rgba(38, 50, 56, .76) !important;
  transition: background-color .15s ease-in-out;
}
#floatingCall .container:hover {
  cursor: pointer;
  background-color: rgba(38, 50, 56, .9) !important;
}
#floatingCall .menu {
  display: inline-block !important;
}
#containerBtnDial {
  display: flex;
  width: 35vw !important;
  justify-content: space-around !important;
  margin-left: 2vw !important;
}
.container-content {
  position: relative;
  height: fit-content;
  padding: 16px !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.container-content-2 {
  height: fit-content;
  padding: 0 !important;
  margin-right: 0 !important;
}

#floatingCall .extra-alert {
  background-color: #f44336ed !important;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: auto;
  padding: 2%;
  transform-origin: top center;
  animation: appearFromTop  0.5s ease-out;
}
#floatingCall .extra-warning {
  background-color: #ffb808eb !important;
  left: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  min-width: 67px;
  transform-origin: left center;
  animation: appearFromLeft 0.5s ease-out;
}
.rotating-clock {
  margin-right: 0.1rem;
  animation: rotateAnimation 1s ease-in-out infinite;
}

@keyframes rotateAnimation {
  0%, 100% {
    transform-origin: center center;
    transform: rotate(-20deg);
  }
  50% {
    transform-origin: center center;
    transform: rotate(20deg);
  }
}

@keyframes appearFromLeft {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes appearFromTop {
  from {
    transform: scaleY(0);
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
}
.space-simulated {
  padding: 1em 1em;
}
</style>


// WEBPACK FOOTER //
// src/components/CallCenter/Dialer.vue